import { oneFromSnapshot } from "@buildwithflux/firestore-compatibility-layer";
export class FirestoreUserUiStateRepository {
    db;
    constructor(db) {
        this.db = db;
    }
    /** @inheritDoc */
    async getUiState(documentUid, userUid) {
        return oneFromSnapshot(await this.db.documentUserUiStatesCollection(documentUid).doc(userUid).get(), () => undefined);
    }
    /** @inheritDoc */
    async setUiState(uiState, documentUid, userUid) {
        await this.db.documentUserUiStatesCollection(documentUid).doc(userUid).set(uiState, { merge: true });
    }
    /** @inheritDoc */
    async dismissAutoLayoutSnackbar(documentUid, userUid, jobUid, statusKey) {
        await this.db
            .documentUserUiStatesCollection(documentUid)
            .doc(userUid)
            .set({
            autoLayoutSnackbarDismissals: {
                [jobUid]: {
                    [statusKey]: true,
                },
            },
        }, { merge: true });
    }
    /** @inheritDoc */
    async isAutoLayoutSnackbarDismissed(documentUid, userUid, jobUid, statusKey) {
        const uiState = await this.getUiState(documentUid, userUid);
        return uiState?.autoLayoutSnackbarDismissals?.[jobUid]?.[statusKey] === true;
    }
    /** @inheritDoc */
    async clearAutoLayoutSnackbarDismissal(documentUid, userUid, jobUid, statusKey) {
        await this.db
            .documentUserUiStatesCollection(documentUid)
            .doc(userUid)
            .set({
            autoLayoutSnackbarDismissals: {
                [jobUid]: {
                    [statusKey]: false,
                },
            },
        }, { merge: true });
    }
}
//# sourceMappingURL=FirestoreUserUiStateRepository.js.map